"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createPredicateIndexFinder = _interopRequireDefault(require("./_createPredicateIndexFinder.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Returns the last index on an array-like that passes a truth test.
var _default = (0, _createPredicateIndexFinder.default)(-1);

exports.default = _default;